// extracted by mini-css-extract-plugin
export default {"tupacGrid":"fn-z","tupacHeader":"gn-z","tupacHeader2":"hn-z","tupacMenu":"in-z","tupacMenu2":"jn-z","tupacMain":"kn-z","tupacMain2":"ln-z"};